import { assertNever } from 'owa-assert';
import { ControlIcons } from 'owa-control-icons';
import { FolderRowData } from '../types/FolderRowData';
import { getStore } from '../store/store';
import { isStoreWithOneDriveProFoldersData } from '../utils/typeGuards';
import { ShareableFolderModel } from '../store/schema/FolderModel';

export function getAllFolderRows(): FolderRowData[] {
    const store = getStore();

    if (isStoreWithOneDriveProFoldersData(store)) {
        return store.folders.map(createFolderRowData);
    }

    return assertNever(store);
}

function createFolderRowData(folder: ShareableFolderModel) {
    const shareableFolderRow: FolderRowData = {
        key: folder.id,
        icon: ControlIcons.FabricFolder,
        name: folder.name,
    };

    return shareableFolderRow;
}
